import { InferMutationResult } from "@trpc/react-query/dist/utils/inferReactQueryProcedure";
import { AnyProcedure } from "@trpc/server";
import { ButtonWithPopper } from "#next/components/reusable/ButtonWithPopper";
import { LoadingButton } from "@mui/lab";
import { TooltipForDisabledComponent } from "#next/components/search-builder/Block";
import SaveIcon from "@mui/icons-material/Save";

export function SaveButton<T extends InferMutationResult<AnyProcedure>>({
  disabled,
  disabledReason,
  onSaveClick,
  mutation,
}: {
  disabled: boolean;
  disabledReason?: string;
  onSaveClick: () => void;
  mutation: T;
}) {
  return (
    <ButtonWithPopper
      popperText="Changes saved"
      showPopper={mutation.isSuccess}
      renderButton={(setPopperAnchorEl) => {
        const button = (
          <LoadingButton
            size="small"
            disabled={disabled}
            variant="contained"
            color="success"
            onClick={(event) => {
              setPopperAnchorEl(event.currentTarget);
              onSaveClick();
            }}
            loadingPosition="start"
            loading={mutation.isLoading}
            startIcon={<SaveIcon />}
          >
            Save
          </LoadingButton>
        );

        if (disabledReason) {
          return (
            <TooltipForDisabledComponent disabledTooltipText={disabledReason}>
              {button}
            </TooltipForDisabledComponent>
          );
        }
        return button;
      }}
    />
  );
}
